(function () {

  /* Draait op elke productpagina met een matentabel.
     ⚠ De sectie main-product wordt TWEE keer gerenderd (het thema doet dat voor de
     quick-buy), dus dit bestand komt ook twee keer als <script src> voorbij. De guard
     hieronder zorgt dat we één keer draaien. */
  if (window.es7MaattabelGeladen) return;
  window.es7MaattabelGeladen = true;

  /* Koppelt de landen-pulldown en de cm/inches-schakelaar binnen `wortel` aan `tabel`.
     De landnamen komen uit de lijst zelf, zodat dit bestand een gewoon asset kan zijn. */
  function bedienKiezers(wortel, tabel) {
    var landknop = wortel.querySelector('[data-es7-mt-landknop]');
    var landlijst = wortel.querySelector('[data-es7-mt-landlijst]');
    var landnu = wortel.querySelector('[data-es7-mt-landnu]');
    if (!tabel || !landknop || !landlijst || !landnu) return;

    var LANDEN = [].map.call(landlijst.querySelectorAll('[data-es7-mt-land]'),
      function (b) { return (b.textContent || '').trim(); });

    function sluitLijst() {
      landlijst.hidden = true;
      landknop.setAttribute('aria-expanded', 'false');
    }

    landknop.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = landlijst.hidden;
      landlijst.hidden = !open;
      landknop.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    landlijst.addEventListener('click', function (e) {
      var b = e.target.closest('[data-es7-mt-land]');
      if (!b) return;
      var i = b.getAttribute('data-es7-mt-land');
      tabel.setAttribute('data-land', i);
      landnu.textContent = LANDEN[i];
      landlijst.querySelectorAll('button').forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
      sluitLijst();
    });

    document.addEventListener('click', function (e) {
      if (!landlijst.hidden && !wortel.contains(e.target)) sluitLijst();
      else if (!landlijst.hidden && !e.target.closest('.es7-mt__land')) sluitLijst();
    });

    var noot = wortel.querySelector('[data-es7-mt-ehnaam]');
    wortel.querySelectorAll('[data-es7-mt-eenheid]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        tabel.setAttribute('data-eenheid', r.value);
        if (noot) noot.textContent = r.value === 'cm' ? (noot.getAttribute('data-cm-label') || 'centimeters') : (noot.getAttribute('data-inch-label') || 'inches');
      });
    });
  }

  /* Klapt "Internationale equivalenten" open en dicht binnen `wortel`. */
  function bedienInter(wortel) {
    var knop = wortel.querySelector('[data-es7-mt-inter]');
    var vak = wortel.querySelector('[data-es7-mt-interpaneel]');
    if (!knop || !vak) return;
    knop.addEventListener('click', function () {
      var open = vak.hidden;
      vak.hidden = !open;
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function () { knop.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
    });
  }

  /* ---- losse pagina /pages/maattabel: elk blok heeft zijn eigen tabel en kiezers ---- */
  document.querySelectorAll('.es7-mt__pagina .es7-mt__blok').forEach(function (blok) {
    bedienKiezers(blok, blok.querySelector('[data-es7-mt-tabel]'));
    bedienInter(blok);
  });

  (function () {
    /* de maat van dit product die de klant nu heeft gekozen; gebruikt om de rij
       op te lichten. HAPPY XL geldt als XXL (afspraak 18 aug). */
    var MIJNMAAT = '';

    /* Alles staat TWEE keer in de pagina (main-product wordt ook voor de quick-buy
       gerenderd). We houden het eerste exemplaar en gooien de rest weg — anders blijft
       er een verborgen bronknop rondslingeren die hangOp() voor een echte knop aanziet.
       Zelfde aanpak als de koopflow met zijn bladen. */
    function eersteEnRuimOp(kies) {
      var alle = document.querySelectorAll(kies);
      for (var i = 1; i < alle.length; i++) alle[i].remove();
      return alle[0] || null;
    }

    var paneel   = eersteEnRuimOp('[data-es7-mt-paneel]');
    var overlay  = eersteEnRuimOp('[data-es7-mt-overlay]');
    var bronknop = eersteEnRuimOp('[data-es7-mt-open]');
    if (!paneel || !overlay || !bronknop) return;

    var tabel = paneel.querySelector('[data-es7-mt-tabel]');
    var terug = paneel.querySelector('[data-es7-mt-terug]');
    var vanuitBlad = false;

    /* Heeft de klant zelf een maat gekozen? Gemeten: het thema vuurt variant:change
       NIET bij het laden, alleen na een echte wissel — dus dit is een betrouwbaar
       signaal, ook als de koopflow uitstaat en er geen maatvak is. */
    var zelfGekozen = /[?&]variant=/.test(location.search);
    document.addEventListener('variant:change', function () { zelfGekozen = true; });

    /* ---------- openen en sluiten ---------- */
    function maatblad() { return document.querySelector('[data-es7-kf-blad="maat"]'); }

    function open(uitBlad) {
      vanuitBlad = !!uitBlad;
      if (terug) terug.hidden = !vanuitBlad;

      /* komt de klant uit het maat-blad van de koopflow? Dan dat blad netjes via
         zijn eigen sluitknop dichtdoen — niet zelf aan zijn klassen zitten. */
      if (vanuitBlad) {
        var blad = maatblad();
        var sluit = blad && blad.querySelector('[data-es7-kf-dicht]');
        if (sluit) sluit.click();
      }

      markeerMaat();
      paneel.hidden = false;
      overlay.hidden = false;
      setTimeout(function () {
        paneel.classList.add('is-open');
        overlay.classList.add('is-open');
      }, 20);
    }

    function dicht(terugNaarBlad) {
      paneel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      /* De landen-pulldown moet mee dicht. Hier stond een aanroep naar een functie
         die niet bestaat: hij heet sluitLijst() en zit binnen bedienKiezers(), dus
         buiten bereik. Gevolg: dicht() brak hier af, de setTimeout hieronder werd
         nooit bereikt en de overlay bleef over de pagina liggen — daarna kon je
         niets meer aanklikken (19 aug). */
      var mtLijst = paneel.querySelector('[data-es7-mt-landlijst]');
      if (mtLijst) mtLijst.hidden = true;
      setTimeout(function () { paneel.hidden = true; overlay.hidden = true; }, 300);

      if (terugNaarBlad && vanuitBlad) {
        var vak = document.querySelector('[data-es7-kf-maatvak]');
        if (vak) setTimeout(function () { vak.click(); }, 160);
      }
      vanuitBlad = false;
    }

    overlay.addEventListener('click', function () { dicht(false); });
    paneel.querySelector('[data-es7-mt-dicht]').addEventListener('click', function () { dicht(false); });
    if (terug) terug.addEventListener('click', function () { dicht(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !paneel.hidden) dicht(false);
    });

    /* ---------- land + cm/inches ----------
       Als functie, want dit draait op twee plekken: het paneel op de productpagina
       (één tabel) en /pages/maattabel (twee tabellen, elk met eigen kiezers). */
    bedienKiezers(paneel, tabel);

    /* ---------- "Hoe moet ik meten?" springt naar het meet-blok ---------- */
    var hoe = paneel.querySelector('[data-es7-mt-hoe]');
    var meten = paneel.querySelector('[data-es7-mt-meten]');
    if (hoe && meten) {
      hoe.addEventListener('click', function () {
        meten.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---------- internationale equivalenten open/dicht ---------- */
    bedienInter(paneel);

    /* ---------- de rij van de gekozen maat oplichten ---------- */
    function huidigeMaat() {
      /* ⚠ Alleen oplichten als de klant ECHT een maat heeft gekozen.
         Het thema vinkt bij het laden zelf al de eerste leverbare variant aan, dus
         `input:checked` is GEEN bewijs van een keuze. Daardoor lichtte XS op zodra je
         de tabel opende zonder iets te kiezen (Alexander, 19 aug). We kijken nu naar
         twee signalen die wél een echte keuze betekenen. */

      /* 1. koopflow aan: het maatvak toont de gekozen maat; zolang er niets gekozen is
            staat er "MAAT". Dit vak bestaat alleen als de koopflow aanstaat. */
      var naam = document.querySelector('[data-es7-kf-maatnaam]');
      if (naam) {
        var t = (naam.textContent || '').trim();
        return (t && t.toUpperCase() !== (paneel.getAttribute('data-size-placeholder') || 'MAAT').toUpperCase()) ? t : '';
      }

      /* 2. koopflow uit: er is geen maatvak, dus we leunen op de vlag hierboven
            (variant:change of een ?variant= in de URL). Niets daarvan = geen keuze.
            Randgeval: klikt de klant precies de maat die het thema toch al had
            aangevinkt, dan wisselt er niets en licht er niets op. Zeldzaam, en met de
            koopflow aan (de normale situatie) speelt het niet — daar telt het maatvak. */
      if (!zelfGekozen) return '';
      var aan = document.querySelector('.shopify-section--main-product .variant-picker input:checked');
      if (!aan) return '';
      var lab = aan.closest('label') || document.querySelector('label[for="' + aan.id + '"]');
      if (lab) return (lab.textContent || '').trim();
      return aan.value ? String(aan.value).trim() : '';
    }

    function markeerMaat() {
      var m = huidigeMaat().toUpperCase();
      if (m === 'HAPPY XL') m = 'XXL';          /* afspraak 18 aug */
      MIJNMAAT = m;
      tabel.querySelectorAll('tbody tr').forEach(function (tr) {
        var cel = tr.querySelector('th');
        var v = cel ? (cel.textContent || '').trim().toUpperCase() : '';
        tr.classList.toggle('is-mijnmaat', !!m && v === m);
      });
    }

    /* ---------- de knop neerzetten en blijven neerzetten ----------
       Het thema hertekent de infokolom na elke maatwissel, en de koopflow vult
       zijn maat-blad opnieuw. Wat we erin hangen wordt dan weggegooid — dus:
       sjabloon bewaren en blijven herplaatsen (zelfde aanpak als est-paslijn). */
    var sjabloon = bronknop.cloneNode(true);
    sjabloon.hidden = false;
    bronknop.remove();

    function hangOp(doel, uitBlad, waar) {
      if (!doel) return;
      if (doel.querySelector(':scope > .es7-mt__knop')) return;
      var k = sjabloon.cloneNode(true);
      k.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open(uitBlad);
      });
      if (waar === 'na') {
        doel.insertAdjacentElement('afterend', k);
      } else {
        /* 14 sep 2026 — de knop stond ACHTERAAN het maat-blad en kwam daardoor pas
           ná acht maten met voorraadregels in beeld: op een telefoon van 844 px hoog
           op y=776. In Clarity werd er nooit op geklikt. Bij ba&sh (het voorbeeld waar
           dit paneel op is gebouwd) staat de matentabel juist METEEN onder de kop, nog
           vóór de maten — hun link is zelfs maar een onderstreept tekstje en wordt wél
           gezien. Het zat dus in de plek, niet in het uiterlijk.
           Valt de matenlijst weg, dan gewoon achteraan: nooit helemaal niet tonen. */
        var maten = doel.querySelector('.es7-kf__maten');
        if (maten) doel.insertBefore(k, maten);
        else doel.appendChild(k);
      }
    }

    function plaats() {
      /* Bestaat er een maat-blad, dan is DAT de plek — en niets anders.
         ⚠ Eerder keek deze functie naar de body-vlag data-es7-kf-actief om te
         beslissen of het vangnet mocht plaatsen. Met een defer-script draait dit
         soms vóórdat de koopflow die vlag zet: dan zette het vangnet er een tweede
         knop onder de (verborgen) maat-hokjes, die er nooit meer wegging. Het
         bestaan van het blad is een betrouwbaar signaal, de timing van de vlag niet. */
      var blad = maatblad();
      if (blad) {
        hangOp(blad, true, 'in');
        document.querySelectorAll('.es7-mt__knop').forEach(function (k) {
          if (!k.closest('[data-es7-kf-blad]')) k.remove();
        });
        return;
      }

      /* Geen maat-blad = koopflow uit → onder de maat-hokjes van het thema. */
      var kiezers = document.querySelectorAll('.shopify-section--main-product .product-info .variant-picker');
      var doel = null;
      kiezers.forEach(function (k) { if (k.querySelector('.block-swatch')) doel = k; });
      if (!doel) doel = kiezers[kiezers.length - 1];
      if (doel && !(doel.nextElementSibling && doel.nextElementSibling.classList.contains('es7-mt__knop'))) {
        hangOp(doel, false, 'na');
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plaats);
    else plaats();
    document.addEventListener('variant:change', function () {
      setTimeout(function () { plaats(); markeerMaat(); }, 120);
      setTimeout(plaats, 800);
    });
    setInterval(plaats, 1200);
  })();

})();
